import React from 'react';
import { cn } from '../../lib/cn';

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

// Bloco de carregamento com leve pulsação
export const Skeleton: React.FC<SkeletonProps> = ({ className, ...props }) => (
  <div className={cn('animate-pulse rounded-md bg-surface-3', className)} {...props} />
);

// Lista de linhas para representar itens carregando (ex.: lista de projetos)
export const SkeletonList: React.FC<{ rows?: number; className?: string }> = ({ rows = 6, className }) => (
  <div className={cn('flex flex-col gap-1.5', className)}>
    {Array.from({ length: rows }).map((_, i) => (
      <Skeleton key={i} className="h-9 w-full" />
    ))}
  </div>
);
